import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=691c0015&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c0015",
  null
  
)

export default component.exports